
import deepCopy from 'deepcopy';

function executeSetEdipart({ commit }, edipart) {
	commit('setEdipart', edipart);
}

function executeSaveInboundSettings({ state, commit, dispatch }, inboundEdiSetting) {
	commit('updateInboundEdiSetting', inboundEdiSetting);
	let edipartCopy = deepCopy(state.edipart);
	dispatch('edipart/executeCreatePatchAndSave', edipartCopy, { root: true });
}


function executeSaveOutboundSettings({ state, commit, dispatch }, outboundSetting) {
	commit('updateOutboundEdiSetting', outboundSetting);
	let edipartCopy = deepCopy(state.edipart);
	dispatch('edipart/executeCreatePatchAndSave', edipartCopy, { root: true });
}

function executeAddInboundSettingAndPatch({ state, commit, dispatch }, inboundSetup) {
	let edipartCopy = deepCopy(state.edipart);
	edipartCopy.inboundSetups.push(inboundSetup);
	dispatch('edipart/executeCreatePatchAndSave', edipartCopy, { root: true });
	commit('pushInboundEdiSetup', inboundSetup);
}

function executeAddOutboundSettingAndPatch({ state, commit, dispatch }, outboundSetup) {
	let edipartCopy = deepCopy(state.edipart);
	edipartCopy.outboundSetups.push(outboundSetup);
	dispatch('edipart/executeCreatePatchAndSave', edipartCopy, { root: true });
	commit('pushOutboundEdiSetup', outboundSetup);
}


function executeDeleteSetup({ state, commit, dispatch }, { setups, key }) {
	let edipartCopy = deepCopy(state.edipart);
	for (let setup of setups) {
		let index = edipartCopy[key].findIndex(x => x.id === setup.id);
		edipartCopy[key].splice(index, 1);
	}
	dispatch('edipart/executeCreatePatchAndSave', edipartCopy, { root: true });
	commit('setEdipart', edipartCopy);

}



export default { executeDeleteSetup, executeSetEdipart, executeSaveInboundSettings, executeAddInboundSettingAndPatch, executeAddOutboundSettingAndPatch, executeSaveOutboundSettings };